"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _stores = require("@seedlang/stores");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var LeagueShowWrapper = function LeagueShowWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _props$params;
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      if (!_state.AppUI.layout.isNative && (0, _utils.isBlank)(props.league) && (_props$params = props.params) !== null && _props$params !== void 0 && _props$params.leagueId) {
        _this.getLeague(_this.afterGetShow);
      }
      if ((0, _utils.isBlank)(_this.props.user) && !_state.AppUI.userStore.hasShowData) {
        _state.AppUI.userStore.getShow({
          ids: {
            userId: _this.userId
          }
        });
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _prevProps$params, _this$props$params;
        if (!_state.AppUI.layout.isNative && ((_prevProps$params = prevProps.params) === null || _prevProps$params === void 0 ? void 0 : _prevProps$params.leagueId) !== ((_this$props$params = this.props.params) === null || _this$props$params === void 0 ? void 0 : _this$props$params.leagueId)) {
          this.getLeague();
        }
      }
    }, {
      key: "getLeague",
      value: function getLeague(callback) {
        _stores.LeagueStore.getShow({
          ids: {
            leagueId: this.leagueId
          }
        }, callback);
      }
    }, {
      key: "afterGetShow",
      value: function afterGetShow(resp) {
        _stores.LeagueStore.setShowData(resp);
      }
    }, {
      key: "leagueId",
      get: function get() {
        return _state.AppUI.layout.isNative ? this.props.leagueId : this.props.params.leagueId;
      }
    }, {
      key: "league",
      get: function get() {
        if ((0, _utils.isBlank)(this.props.league)) {
          if (this.leagueId) {
            return _stores.LeagueStore.showData;
          }
          return _state.AppUI.user.currentLeague;
        }
        return this.props.league;
      }
    }, {
      key: "leaguePosition",
      get: function get() {
        var _this$league;
        return (_this$league = this.league) === null || _this$league === void 0 || (_this$league = _this$league.leagueLevel) === null || _this$league === void 0 ? void 0 : _this$league.position;
      }
    }, {
      key: "leagueImageSrc",
      get: function get() {
        return this.leaguePosition ? "/images/leagues/league_".concat(this.leaguePosition, ".png") : null;
      }
    }, {
      key: "userLeague",
      get: function get() {
        var _this$league2,
          _this2 = this;
        return (_this$league2 = this.league) === null || _this$league2 === void 0 || (_this$league2 = _this$league2.userLeagues) === null || _this$league2 === void 0 ? void 0 : _this$league2.find(function (ul) {
          return ul.userId === _this2.userId;
        });
      }
    }, {
      key: "isUsersLastLeague",
      get: function get() {
        var _this$user, _this$league3, _this$user$currentLea;
        return (0, _utils.isPresent)((_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.currentLeague) && ((_this$league3 = this.league) === null || _this$league3 === void 0 ? void 0 : _this$league3.id) === ((_this$user$currentLea = this.user.currentLeague) === null || _this$user$currentLea === void 0 ? void 0 : _this$user$currentLea.id);
      }
    }, {
      key: "userRank",
      get: function get() {
        var _this$userLeague;
        if (!this.user) {
          return null;
        }
        return ((_this$userLeague = this.userLeague) === null || _this$userLeague === void 0 ? void 0 : _this$userLeague.rank) || 0;
      }
    }, {
      key: "totalMembers",
      get: function get() {
        var _this$league4;
        return ((_this$league4 = this.league) === null || _this$league4 === void 0 || (_this$league4 = _this$league4.userLeagues) === null || _this$league4 === void 0 ? void 0 : _this$league4.length) || 0;
      }
    }, {
      key: "userId",
      get: function get() {
        var _this$props$params2;
        if (this.props.user) {
          return this.props.user.id;
        }
        if ((_this$props$params2 = this.props.params) !== null && _this$props$params2 !== void 0 && _this$props$params2.userId) {
          var _this$props$params3;
          return (_this$props$params3 = this.props.params) === null || _this$props$params3 === void 0 ? void 0 : _this$props$params3.userId;
        }
        return _state.AppUI.user.id;
      }
    }, {
      key: "user",
      get: function get() {
        var _AppUI$userStore$show;
        if (this.userId === _state.AppUI.user.id) {
          return _state.AppUI.user;
        }
        if (this.userId === ((_AppUI$userStore$show = _state.AppUI.userStore.showData) === null || _AppUI$userStore$show === void 0 ? void 0 : _AppUI$userStore$show.id)) {
          return _state.AppUI.userStore.showData;
        }
        return null;
      }
    }, {
      key: "userIsAuthUser",
      get: function get() {
        return this.userId === _state.AppUI.user.id;
      }
    }, {
      key: "userIsInLeague",
      get: function get() {
        var _this$league5,
          _this3 = this;
        return (_this$league5 = this.league) === null || _this$league5 === void 0 || (_this$league5 = _this$league5.userLeagues) === null || _this$league5 === void 0 ? void 0 : _this$league5.some(function (ul) {
          return ul.userId === _this3.userId;
        });
      }
    }, {
      key: "leagueEndedText",
      get: function get() {
        var _this$league6;
        return "This league ends in ".concat((_this$league6 = this.league) === null || _this$league6 === void 0 ? void 0 : _this$league6.timeFromNow, ".");
      }
    }, {
      key: "isFirstLeagueMember",
      get: function get() {
        var _this$league7, _this$league8;
        return this.userIsAuthUser && ((_this$league7 = this.league) === null || _this$league7 === void 0 ? void 0 : _this$league7.usersCount) === 1 && !((_this$league8 = this.league) !== null && _this$league8 !== void 0 && _this$league8.ended);
      }
    }, {
      key: "statusText",
      get: function get() {
        var _this$userLeague2, _this$userLeague3, _this$userLeague4, _this$userLeague5, _this$league9, _this$league10;
        // empty string is because by the last league you know how the leagues work
        var rank = "".concat(this.userIsAuthUser ? 'You are' : "".concat((_this$userLeague2 = this.userLeague) === null || _this$userLeague2 === void 0 || (_this$userLeague2 = _this$userLeague2.user) === null || _this$userLeague2 === void 0 ? void 0 : _this$userLeague2.name, " is"), " #").concat((_this$userLeague3 = this.userLeague) === null || _this$userLeague3 === void 0 ? void 0 : _this$userLeague3.rank, ".");
        var status = (_this$userLeague4 = this.userLeague) !== null && _this$userLeague4 !== void 0 && _this$userLeague4.demoted ? 'Oh no! You are in danger of being demoted.' : (_this$userLeague5 = this.userLeague) !== null && _this$userLeague5 !== void 0 && _this$userLeague5.promoted ? 'Congrats, you are in the promotion zone!' : ((_this$league9 = this.league) === null || _this$league9 === void 0 || (_this$league9 = _this$league9.leagueLevel) === null || _this$league9 === void 0 ? void 0 : _this$league9.promotionCount) === 0 ? '' : "The first ".concat((_this$league10 = this.league) === null || _this$league10 === void 0 || (_this$league10 = _this$league10.leagueLevel) === null || _this$league10 === void 0 ? void 0 : _this$league10.promotionCount, " will be promoted to the next league.");
        return "".concat(rank, " ").concat(status);
      }
    }, {
      key: "leagueEndedStatusText",
      get: function get() {
        if ((0, _utils.isPresent)(this.userLeague)) {
          var _this$userLeague$user, _this$userLeague6, _this$league11;
          return "".concat(this.userIsAuthUser ? 'You' : (_this$userLeague$user = this.userLeague.user) === null || _this$userLeague$user === void 0 ? void 0 : _this$userLeague$user.name, " finished #").concat((_this$userLeague6 = this.userLeague) === null || _this$userLeague6 === void 0 ? void 0 : _this$userLeague6.rank, ",").concat(this.userLeague.promoted ? " and ".concat(this.userIsAuthUser ? 'were' : 'was', " promoted to the next league.") : this.userLeague.demoted ? " and ".concat(this.userIsAuthUser ? 'were' : 'was', " demoted to the previous league.") : " and will stay in the ".concat((_this$league11 = this.league) === null || _this$league11 === void 0 || (_this$league11 = _this$league11.leagueLevel) === null || _this$league11 === void 0 ? void 0 : _this$league11.name, "."));
        }
        return '';
      }
    }, {
      key: "clearLeagueProgress",
      value: function clearLeagueProgress() {
        _state.AppUI.designateUiElementAsSeen('league-mobile-onboarding');
        _state.AppUI.authUserStore.clearLeagueProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "afterClearProgress",
      value: function afterClearProgress() {
        this.getLeague();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          league: this.league,
          user: this.user,
          leaguePosition: this.leaguePosition,
          leagueImageSrc: this.leagueImageSrc,
          userRank: this.userRank,
          totalMembers: this.totalMembers,
          userId: this.userId,
          userIsAuthUser: this.userIsAuthUser,
          userLeague: this.userLeague,
          isUsersLastLeague: this.isUsersLastLeague,
          userIsInLeague: this.userIsInLeague,
          firstLeagueMemberText: "You are the first member of this league. New members will be added soon!",
          isFirstLeagueMember: this.isFirstLeagueMember,
          leagueEndedText: this.leagueEndedText,
          statusText: this.statusText,
          leagueEndedStatusText: this.leagueEndedStatusText,
          clearLeagueProgress: this.clearLeagueProgress
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "getLeague", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getLeague"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetShow", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetShow"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leagueId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leagueId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "league", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "league"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leaguePosition", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leaguePosition"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leagueImageSrc", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leagueImageSrc"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userLeague", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userLeague"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isUsersLastLeague", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isUsersLastLeague"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userRank", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userRank"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "totalMembers", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "totalMembers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "user"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userIsAuthUser", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userIsAuthUser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userIsInLeague", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userIsInLeague"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leagueEndedText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leagueEndedText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isFirstLeagueMember", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isFirstLeagueMember"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "statusText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "statusText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "leagueEndedStatusText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "leagueEndedStatusText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearLeagueProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearLeagueProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterClearProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterClearProgress"), _class2.prototype), _class2)) || _class;
};
LeagueShowWrapper.displayName = 'LeagueShowWrapper';
var _default = exports["default"] = LeagueShowWrapper;